export type User = {
  id?: string;
  email: string;
  name: string | undefined;
  phoneNumber: string | undefined;
  status: string;
  emailVerified: boolean;
  phoneNumberVerified: boolean;
  created: string;
  enabled: boolean;
  group: UserGroup;
};

export enum UserGroup {
  ADMINISTRATORS = "administrator",
  CREWING_MANAGERS = "crewing_manager",
  CREWING_SPECIALISTS = "crewing_specialist",
  CREWING_EXECS = "crewing_exec",
  FLEET_EXECS = "fleet_exec",
  MARINERS = "mariner",
  HUMAN_RESOURCES = "human_resource",
  HUMAN_RESOURCES_ADMINS = "human_resources_admin",
  VESSEL_EXECS = "vessel_exec",
  CREWING_EVAL_SPECIALISTS = "crewing_eval_specialist",
}

export enum RegistrationStatus {
  CONFIRMED = "CONFIRMED",
  FORCE_CHANGE_PASSWORD = "FORCE_CHANGE_PASSWORD",
  NOT_REGISTERED = "NOT_REGISTERED",
}
